import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LanguageProvider } from '@spa/i18n';
import '@spa/setup/b2bAssetLocation';
import '@spa/styles/app.css';
import '@spa/styles/stencilOverrides.css';
import App from '@spa/App';

// @todo - remove this once we have a dark mode toggle in the app
document.documentElement.classList.add('force-light');

const container = document.getElementById('spa-app');

if (container) {
  createRoot(container).render(
    <StrictMode>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </StrictMode>
  );
}
